import { useEffect, useState } from "react";
import { LocalStorage } from "../../types/local_storage.enum";
import { Loader2 } from "lucide-react";

interface Props {
  isOpen: boolean;
}
export default function CountdownModal({ isOpen }: Props) {
  const [count, setCount] = useState(3);
  useEffect(() => {
    if (!isOpen) return;
    setCount(3);
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setTimeout(() => {
            localStorage.removeItem(LocalStorage.IS_NEW);
          }, 500);
        }
        return prev - 1;
      });
    }, 400);

    return () => clearInterval(interval);
  }, [isOpen]);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[5000] flex gap-2 items-center justify-center backdrop-blur-sm bg-black/55 ">
      <div className="flex p-10 py-6  bg-white items-center border dark:bg-gray-800 border-accent-500 justify-center gap-4 text-accent-500 rounded-md ">
          <Loader2 className="w-6 h-6 animate-spin text-accent-500" />
          <span className="text-sm font-medium text-accent-500">Starting...</span>
        </div>
    </div>
  );
}
